<template>
  <div class="wg-row com-anm22-app-inner-wrapper">
    <!-- MODALE gestione categoria -->
    <wg-modal 
        :width="windowWidth > 900 ? '900px' : '90%'" 
        v-if="showCategoryDialog" 
        :portal="true" 
        @closeModal="closeCategory">
      <div class="com-anm22-app-text-xl" slot="header">
        {{ this.selectedCategory.id 
            ? $anm22.strLang(lang, 'Edit Category', 'Modifica categoria')
            : $anm22.strLang(lang, 'Add Category', 'Nuova categoria')
        }}
      </div>
      <category-detail
          slot="body" 
          :categoryRef="selectedCategory"
      ></category-detail>
    </wg-modal>
    <!-- TITOLO PAGINA -->
    <div class="wg-row">
      <div class="com-anm22-page-title" style="font-size:24px;">
        {{ $anm22.strLang(lang, 'Categories', 'Categorie') }}
      </div>
    </div>
    <!-- PULSANTI -->
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
      <button class="small" @click="newCategory">
        <img :src="$anm22.icons.getWorldIcon('add')">
        <div v-if="windowWidth > 767">{{ $anm22.strLang(lang, 'New', 'Nuovo') }}</div>
      </button>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <!-- LISTA Categorie -->
    <div class="wg-row" :style="{ height: listHeight+'px' }">
      <w-g-list
          v-if="categories.length > 0"
          :loading="loading"
          :keyField="'id'"
          :clickFn="c => openCategory(c)"
          :headerItems="listHeader"
          :itemsToDisplay="listRows"
      >
        <template v-slot:default="{ element }">
          <div 
              class="wg-row item-row"
              v-anm22-drag-and-drop="{
                group: (!element.parent ? 'main' : element.parent),
                start: () => dragStart(element.id),
                drop: () => drop(element.id)
              }">
            <div class="wg-col wg-xs-9" :style="{cursor: 'pointer', paddingLeft: !element.parent ? '0' : '20px'}">
              <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                <img :src="$anm22.icons.getWorldIcon('dragHandle')" class="com-anm22-app-img-s" style="margin-right:5px;">
                <div class="com-anm22-app-text-l ellipsed">
                  {{ element.langName }}
                </div>
              </div>
            </div>
            <div class="wg-col wg-xs-1" @click.stop="() => {}">
              <input 
                  :id="'check-'+element.id"
                  type="checkbox"
                  style="display:none;"
                  :value="element.visible"
                  @change="changeVisibility(element)">
              <label class="checkbox-label" :for="'check-'+element.id">
                {{ element.visible ? '✔' : '' }}
              </label>
            </div>
            <div class="wg-col wg-xs-2 display-flex" style="justify-content:flex-end;">
              <div class="com-anm22-app-text-l" >
                {{ element.defaultVat + '%' }}
              </div>
            </div>
          </div>
        </template>
      </w-g-list>
      <div v-else class="com-anm22-app-text-xxl">
        {{ $anm22.strLang(lang, 'No Categories', 'Nessuna categoria') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WGList from '../../../../../world/spa/components/WGList.vue';
import CategoryDetail from '../../components/inventory/CategoryDetail.vue';
import { Anm22DragAndDrop } from '../../../../../world/spa/directives/Anm22DragAndDrop';

export default {
  data() {
    return {
      loading: false,
      /* Gestione prodotto */
      selectedCategory: null,
      showCategoryDialog: false,
      /* Drag and Drop */
      dragging: null //id Categoria che si sta draggando
    }
  },
  components: {
    WGList,
    CategoryDetail
  },
  directives: {
    Anm22DragAndDrop
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    listHeight() {
      return this.windowHeight - 250;
    },
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    categories() {
      return this.$store.getters['foodCategories/getByLicense'](this.license.id).filter(c => !c.deleted);
    },
    listHeader() {
      return [
        {
          field: 'langName',
          label: this.$anm22.strLang(this.lang, 'Name', 'Nome'),
          class: 'wg-xs-9',
          disabled: false,
        },
        {
          field: 'visible',
          label: this.$anm22.strLang(this.lang, 'Visible', 'Visibile'),
          class: 'wg-xs-1',
          disabled: true,
        },
        {
          field: 'vat',
          label: this.$anm22.strLang(this.lang, 'VAT', 'IVA'),
          class: 'wg-xs-2',
          style: { justifyContent: 'flex-end' },
          disabled: false,
        }
      ]
    },
    listRows() {
      const list = [];
      if(this.categories) {
        const mainCategories = this.categories.filter(c => c.parent == 0).sort((a,b) => a.ordering - b.ordering);
        mainCategories.forEach(mainCategory => {
          list.push({
            ...mainCategory,
            'list-metadata': {
              type: 'item',
            }
          });
          const children = this.categories
            .filter(c => c.parent === mainCategory.id)
            .sort((a,b) => a.ordering - b.ordering);
          children.forEach(child => {
            list.push({
              ...child,
              'list-metadata': {
                type: 'item',
              }
            });
          })
        })
      }
      return list;
    },
  },
  methods: {
    newCategory() {
      const localId = this.$anm22.genLocalId();
      this.openCategory({
        id: localId,
        dbKey: localId,
        license: this.license.id,
        defaultVat: '',
        image: '',
        iconName: '',
        colorString: '',
        visible: true,
        visibleByCustomer: true,
        ordering: '',
        parent: 0,
        idPrinter: 0,
        variations: [],
        deleted: false,
        limited: false,
        shifts: []
      });
    },
    openCategory(c) {
      this.selectedCategory = c;
      this.showCategoryDialog = true;
    },
    closeCategory() {
      this.showCategoryDialog = false;
      this.selectedCategory = null;
    }, 
    dragStart(id) {
      this.dragging = id;
    },
    async drop(id) {
      try {
        // check offline object
        if(!Number.isInteger(this.dragging) || !Number.isInteger(id)) {
          throw new Error('Local object');
        }
        const response = await this.$http.post('inventory/switch-categories', {
          first: this.dragging,
          second: id
        });
        this.$store.dispatch('foodCategories/update', {
          vlf: this.$vlf('foodCategories'), objs: response.data.categories
        });
      } catch(e) {
        const first = this.categories.find(c => c.id === this.dragging);
        const second = this.categories.find(c => c.id === id);
        const temp = first.ordering;
        first.ordering = second.ordering;
        second.ordering = temp;
        await Promise.all([
          this.$store.dispatch('foodCategories/update', {
            vlf: this.$vlf('foodCategories'), objs: [ first ]
          }),
          this.$store.dispatch('offline/saveSyncTuple', {
            _vue: this,
            _class: "FoodCategory",
            _table: "foodCategories",
            mode: 'edit',
            type: 'obj',
            obj: first
          }),
          this.$store.dispatch('foodCategories/update', {
            vlf: this.$vlf('foodCategories'), objs: [ second ]
          }),
          this.$store.dispatch('offline/saveSyncTuple', {
            _vue: this,
            _class: "FoodCategory",
            _table: "foodCategories",
            mode: 'edit',
            type: 'obj',
            obj: second
          }),
        ]);
      } finally {
        this.dragging = null;
      }
    },
    async changeVisibility(cat) {
      cat.visible = !cat.visible;
      this.$store.dispatch('foodCategories/update', {
        vlf: this.$vlf('foodCategories'), objs: [cat]
      })
      try {
        // check offline object
        if(!Number.isInteger(cat.id)) {
          throw new Error('Local object');
        }
        this.$http.post('inventory/change-category-visibility', {
          categoryId: cat.id
        });
      } catch(e) {
        this.$store.dispatch('offline/saveSyncTuple', {
          _vue: this,
          _class: "FoodCategory",
          _table: "foodCategories",
          mode: 'edit',
          type: 'obj',
          obj: cat
        });
      }
    },
    loadData() {
      return Promise.all(
        [
          this.$store.dispatch('foodCategories/load', this.$vlf('foodCategories')),
          this.$store.dispatch('foodPrinters/load', this.$vlf('foodPrinters')),
        ]
      )
      .then(() => {
        this.loading = false;
        this.$Progress.finish();
      });
    }
  },
  created() {
    this.loading = true;
    this.loadData();
    //Get orders
    this.$http
      .get("inventory")
      .then(response => {
        Promise.all([
          this.$store.dispatch('foodCategories/update', {
            vlf: this.$vlf('foodCategories'),
            objs: response.data.categories
          })
        ])
        .then(() => {

        })
      });
  },
  watch: {
    categories(newVal, old) {
      if(this.selectedCategory && this.selectedCategory.id) {
        this.selectedCategory = newVal.find(c => c.id === this.selectedCategory.id);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-label {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.item-row {
  height: 36px;
  padding: 10px 0;
  &:hover {
    background-color: #fff;
  }
  .ellipsed {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
